export default (value, lang, options = { minimumSignificantDigits: 1 }) => {
  return new Intl.NumberFormat(lang, options).format(value);
};
